import React, { useEffect, useState } from 'react';
import { renderToBody } from '@/components/cn-picker/render-to-body';
import { CnDatePickerPro, } from '@/components/cn-date-picker-pro';
export function prompt(props) {
    return new Promise((resolve) => {
        const Wrapper = () => {
            const [visible, setVisible] = useState(false);
            useEffect(() => {
                setVisible(true);
            }, []);
            return (React.createElement(CnDatePickerPro, { ...props, visible: visible, onConfirm: (val) => {
                    props.onConfirm?.(val);
                    resolve(val);
                }, onClose: () => {
                    props.onClose?.();
                    setVisible(false);
                    resolve(null);
                }, afterClose: () => {
                    props.afterClose?.();
                    unmount();
                } }));
        };
        const unmount = renderToBody(React.createElement(Wrapper, null));
    });
}
